<script lang="ts">
  let { text = $bindable(), max = 65 }: { text: string; max?: number } = $props();

  const truncated = $derived(text.length > max);
  const displayed = $derived(truncated ? text.slice(0, max) : text);
</script>

<style>
  .root {
    flex: 1;
    min-width: 0;
    word-break: break-word;
    font-weight: 600;
  }

  /* Stacked mobile layout: cap the title at two lines so row heights stay predictable */
  @media (max-width: 639px) {
    .root {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      overflow: hidden;
    }
  }
</style>

<div class="field root">{displayed}{#if truncated}<span class="text-gray-400">&nbsp;...</span>{/if}</div>
